import { NgModule } from '@angular/core';

import { ComponentsModule } from './components/components.module';
import { DirectivesModule } from './directives/directives.module';
import { ModalsModule } from './modals/modals.module';

const SHARED = [ComponentsModule, DirectivesModule, ModalsModule];

@NgModule({
  imports: SHARED,
  exports: SHARED,
})
export class SharedModule {}
